var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-3 widget-container"},[_c('div',{staticClass:"tradingview-widget"}),_c('div',{staticClass:"tradingview-widget"}),_c('div',{staticClass:"tradingview-widget"}),_c('div',{staticClass:"tradingview-widget"})])
}]

export { render, staticRenderFns }